<template>
    <div class="row">
        <h5 class="col-sm-6 col-md-9">{{ __('Shipments by type') }}</h5>
        <div class="col-sm-6 col-md-3 right">
         
        </div>
        <div class="col-sm-12 col-md-12">
            <PieCharts
                :chart-data="dataCollectionSpecies"
                :datasets="chartData"
                :labels="chartData[0].labels"
                v-if="loaded"
            ></PieCharts>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'LoadsBySpecies',

  async mounted () {
    this.loaded = false
    try {
      this.$api.dashboard.charts().then((res) => {
        this.chartData = this.mapChartData(res)
        this.loaded = true
      })
    } catch (e) {
      return false
    }
  },

  data () {
    return {
      labels: [],
      chartData: [],
      dataCollectionSpecies: null,
      loaded: false
    }
  },
  methods: {
    loadsByTypeReport () {
      alert('Full report clicked')
    },

    mapChartData (res) {

       // return  res.shipmentsByKind.data

      var dataSet={
        label:"Default dataset",
        backgroundColor:[],
        data:[],
        labels:[]
      };
      

      _.each(res.shipmentsByKind, function (element) {

        dataSet.data.push(element.data[0])
        dataSet.labels.push(element.label)
        dataSet.backgroundColor.push( `rgb(${Math.floor(Math.random() * (235 - 52 + 1) + 52)}, ${Math.floor(Math.random() * (235 - 52 + 1) + 52)}, ${Math.floor(Math.random() * (235 - 52 + 1) + 52)})`)
      })

      return [dataSet]

      //return _.map(res.shipmentsByKind, function (element) {
      ////  return _.extend({}, element, { backgroundColor: })
     // })
    },

    async filterChart (res) {
      this.loaded = false
      try {
        this.chartData =await this.mapChartData(res)
        this.loaded = true
      } catch (e) {
        return false
      }
    }
  }
}
</script>

